document.addEventListener("DOMContentLoaded", () => {
  const mq = window.matchMedia("(min-width: 992px)");
  let isDesktop = mq.matches;
  let resizeTimeout;

  function handleViewportChange(e) {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const nowDesktop = e.matches;

      // Só recarrega se mudou de estado (mobile ↔ desktop)
      if (nowDesktop !== isDesktop) {
        location.reload();
      }

      isDesktop = nowDesktop;
    }, 300); // ⏱️ debounce de 300ms
  }

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", handleViewportChange);
  } else {
    mq.addListener(handleViewportChange); // Safari mais antigo
  }

  // Barra de navegação
  // let lastScrollTop = 0;
  // const navbar = document.querySelector(".navbar__header");

  // window.addEventListener("scroll", function () {
  //   const currentScroll =
  //     window.pageYOffset || document.documentElement.scrollTop;

  //   if (currentScroll > lastScrollTop && currentScroll > 90) {
  //     navbar.style.top = "-100px";
  //   } else {
  //     navbar.style.top = "0";
  //   }

  //   lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  // });

  const menuItems = document.querySelectorAll(".navbar__header .menu__item");

  menuItems.forEach((item) => {
    const dropdown = item.querySelector(".menu__sublinks");
    if (!dropdown) return;

    if (window.innerWidth > 992) {
      item.addEventListener("mouseenter", () => {
        const rect = dropdown.getBoundingClientRect();

        if (rect.right > window.innerWidth) {
          dropdown.style.left = "auto";
          dropdown.style.right = "0";
        } else {
          dropdown.style.right = "auto";
          dropdown.style.left = "50%";
          dropdown.style.transform = "translateX(-50%)";
        }

        item.classList.add("active");
      });

      item.addEventListener("mouseleave", () => {
        item.classList.remove("active");
      });
    }

    if (window.innerWidth < 992) {
      item.addEventListener("click", (e) => {
        if (e.target.closest(".menu__sublinks a")) return;
        e.preventDefault();

        menuItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("active");
          }
        });

        item.classList.toggle("active");
      });
    }
  });

  // Menu mobile
  const menu = document.querySelector(".navbar__header .menu-mobile");
  const wrapper = document.querySelector(".navbar__header .wrapper-mobile");
  const body = document.querySelector("body");
  const btnToggle = document.querySelector(
    ".navbar__header .navbar__mobile .mobile"
  );
  const btnClose = document.querySelector(".navbar__header .close-btn");
  const links = document.querySelectorAll(".navbar__header .menu-mobile a");

  // Abrir/fechar menu
  function toggleMenuMobile() {
    menu.classList.toggle("active");
    wrapper.classList.toggle("active");
    body.classList.toggle("active");
  }

  // Fechar menu
  function closeMenuMobile() {
    menu.classList.remove("active");
    wrapper.classList.remove("active");
    body.classList.remove("active");
  }

  // Abrir com botão de menu
  btnToggle?.addEventListener("click", function (event) {
    event.stopPropagation();
    toggleMenuMobile();
  });

  // Fechar com botão X
  btnClose?.addEventListener("click", function (event) {
    event.stopPropagation();
    closeMenuMobile();
  });

  // Fechar ao clicar fora do menu
  menu?.addEventListener("click", function (event) {
    if (!wrapper.contains(event.target)) {
      closeMenuMobile();
    }
  });

  // Fechar ao clicar em qualquer link
  links.forEach((link) => {
    link.addEventListener("click", () => {
      closeMenuMobile();
    });
  });

  // Variantes dos cards
  // const variantsCard = document.querySelectorAll(
  //   ".delucca__product-card .swiper"
  // );

  // variantsCard.forEach((wrapper) => {
  //   new Swiper(wrapper, {
  //     slidesPerView: "auto",
  //     spaceBetween: 8,
  //     freeMode: true,
  //     grabCursor: true,
  //   });
  // });
});
(function () {
  "use strict";

  /**
   * Inicializa os Swipers de variantes dentro de um contexto
   * @param {HTMLElement|Document} context
   */
  function initVariantSwipers(context) {
    context = context || document;

    const swipers = context.querySelectorAll(
      ".delucca__product-card .swiper:not(.swiper-initialized)"
    );

    if (!swipers.length) return;

    swipers.forEach((wrapper) => {
      new Swiper(wrapper, {
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
      });
    });
  }

  /**
   * Inicialização no carregamento inicial da página
   */
  function onDomReady() {
    initVariantSwipers(document);
  }

  /**
   * Shopify Sections (renderizadas via AJAX)
   */
  function onShopifySectionLoad(event) {
    if (!event || !event.target) return;
    initVariantSwipers(event.target);
  }

  /**
   * Observer para produtos carregados dinamicamente (infinite scroll / AJAX)
   */
  function observeDynamicProducts() {
    const productContainer =
      document.querySelector("[data-product-grid]") ||
      document.querySelector("#ProductGridContainer") ||
      document.querySelector(".product-grid");

    const target = productContainer || document.body;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          // Se o próprio node for um card
          if (node.matches && node.matches(".delucca__product-card")) {
            initVariantSwipers(node);
            return;
          }

          // Se o node contiver cards
          if (node.querySelectorAll) {
            const cards = node.querySelectorAll(".delucca__product-card");
            if (cards.length) {
              cards.forEach((card) => initVariantSwipers(card));
            }
          }
        });
      });
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  /**
   * Bind de eventos globais
   */
  document.addEventListener("DOMContentLoaded", onDomReady);
  document.addEventListener("shopify:section:load", onShopifySectionLoad);

  /**
   * Start observer
   */
  observeDynamicProducts();
})();